import { useEffect } from "react";
import { useContentful } from "react-contentful";
import { getAssetURL, getEntry } from "../utils/getAssetURL";
import { useSetRecoilState } from "recoil";
import { productCategories } from "../atoms/productAtoms";

const useProductResources = () => {
  const setProductResources = useSetRecoilState(productCategories);

  const { data, loading, error, fetched } = useContentful({
    contentType: "productsPage",
  });

  const {
    title,
    banner,
    productRubricPdf: PDF,
  } = data?.items?.[0]?.fields || {};
  const productRubricPdf = PDF?.fields?.file?.url;

  useEffect(() => {
    const { categories } = data?.items?.[0]?.fields || {};
    if (categories?.length > 0) {
      const processedCategories = categories?.map((item) => {
        return {
          id: item?.fields?.id,
          title: getEntry(data, item?.fields?.title?.sys?.id)?.fields || {},
          banner: getAssetURL(data, item?.fields?.banner?.sys?.id) || "",
          verticalBanner:
            item?.fields?.verticalBanner?.map((item) =>
              getAssetURL(data, item?.sys?.id)
            ) || [],
        };
      });
      setProductResources(processedCategories);
    }
  }, [data, setProductResources]);

  return { title, banner, productRubricPdf, loading, fetched, error };
};

export default useProductResources;
